import { render, staticRenderFns } from "./Applications.vue?vue&type=template&id=aff154ec&scoped=true&"
import script from "./Applications.vue?vue&type=script&lang=ts&"
export * from "./Applications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff154ec",
  null
  
)

export default component.exports